const CURRENT_VERSION = 1;

export default {
  state: {
    version: null
  },

  reducers: {
    setVersionToCurrent: (state) => ({ version: CURRENT_VERSION }),
  },
  effects: dispatch => ({
    runMigrations(payload, rootState) {
      const savedVersion = rootState.versionManager.version;
      if (savedVersion === null) {
        migrations.initial(dispatch, rootState);
        dispatch.versionManager.setVersionToCurrent();
        return;
      }

      if (savedVersion < CURRENT_VERSION) {
        let i = savedVersion + 1;
        while (migrations[i]) {
          migrations[i](dispatch, rootState);
          i++;
        }
      }
      dispatch.versionManager.setVersionToCurrent();
    }
  })
}

const migrations = {
  initial: (dispatch, rootState) => {
    if (rootState.demo.currentPassage !== null) {
      dispatch.demo.clearAllStoryData();
    }
  },
  2: (dispatch, rootState) => {
  }
};